import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import Debug from 'debug';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as fromActions from '../actions/invitations.actions';

import { InvitationService } from '../services/invitation.service';

const debug = Debug('modeso:aumico-lib-users-fe:InvitationEffects');

@Injectable()
export class InvitationEffects {
    constructor(private readonly actions$: Actions, private readonly service: InvitationService) {}

    getInvitation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.invitation.get.type),
            mergeMap(({ payload }) => {
                return this.service.getInvitationByUrl(payload).pipe(
                    map((response) => {
                        return fromActions.invitation.getSuccess({ payload: response });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.invitation.getFailure({ payload: error }));
                    }),
                );
            }),
        ),
    );

    acceptInvitation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.invitation.acceptInvitation.type),
            mergeMap(({ payload }) => {
                const { uuid, acceptInvitationDto, setPassword } = payload;
                return this.service.acceptInvitation$(uuid, acceptInvitationDto, setPassword).pipe(
                    map((oobCode) => fromActions.invitation.acceptInvitationSuccess({ payload: oobCode })),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.invitation.acceptInvitationFailure({ payload: error }));
                    }),
                );
            }),
        ),
    );
}
